export default __webpack_public_path__ + "static/media/ic_oxxo_white.795b49e7.svg";